/**
 * Centralised TanStack Query keys for the fixed-assets resource.
 *
 * A write here persists a **draft**, which moves the register and the journal
 * but no account balance — so `invalidateDraftWrite` invalidates this whole tree
 * plus the journal, and deliberately leaves the accounts alone. Keeping the keys
 * here is what lets that stay a one-liner instead of drifting string literals.
 *
 * `reconciliation` sits under `all` so a register write refetches the tie-out
 * with it: the register side can move while the ledger side has not, and the
 * screen must show that difference rather than a stale agreement.
 */
export const FixedAssetQueryKeys = {
    all: ['fixed-assets'] as const,
    categories: () => [...FixedAssetQueryKeys.all, 'categories'] as const,
    list: (status: string, search: string) =>
        [...FixedAssetQueryKeys.all, 'list', status, search] as const,
    detail: (assetId: string) =>
        [...FixedAssetQueryKeys.all, 'detail', assetId] as const,
    /** Keyed by locale: `accountName` is resolved server-side. */
    reconciliation: (locale: string) =>
        [...FixedAssetQueryKeys.all, 'reconciliation', locale] as const,
};
